import { network } from 'services/network';

import { QueryParams } from 'api/endPoints/getCardMatrixList/types';

export const getCardMatrixList = ({ versionId, itemId, numOfDaysToBeUrgent, filter }: QueryParams) => {
    const params = {
        matrixItemIndex: itemId,
        metaDataId: versionId,
        numOfDaysToBeUrgent,
        paging: {
            page: 0,
            size: 500,
        },
        filter,
    };

    return network.post('api/bo/getCardMatrixList', params).then((response) => {
        return response.data;
    });
};
